module.exports = __webpack_public_path__ + "img/bacteria.035f7fd1.jpg";